import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { constants } from 'src/app/shared/common/contants';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { CommonTs } from 'src/app/shared/common/CommonTs';
import { json } from 'stream/consumers';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
    selector: 'app-etl-migration-popup',
    templateUrl: './etl-migration-popup.component.html',
    styleUrls: ['./etl-migration-popup.component.scss'],
    standalone: false
})
export class EtlMigrationPopupComponent implements OnInit {


  backgroundColorScreen;
  buttonColor;
  backgroundColorButton;

  uploadFile = false;

  selectedExtractionType: string = "CSV Extraction";
  snapshotSelected: any
  migration = {"source":"", "target":"", "dataExtractionType":"", "migrationType":"", "remarks":"", "fileData": {},"selectedObjectGroups":"","dataLakeAndReports":"","dataLakeType":"","DatasetName":"", "persistenceEmr":"No", "persistenceClusterId":"","JSONTOCSV_Validation_Reports":"","sourceextractiontype":"","mappingfileData":{},"intergrator":"","mappingFileversion":"","migrationid":""};
  snapshot:any = []
  fileData={"fileName":"","fileData":""};
  mappingfileData={"mappingFileName":"","mappingFileData":""}
  source = [];
  target = [];
  dataLakeAndReports:any=[];
  dataLakeType:any=[];
  sourceSystemType = "";
  targetSystemType = "";
  partialData = false;
  migrationType: any = [];
  systemNames: any = [];
  persistenceEmr: any = [];
  persistenceClusterId: any = [];
  validation_source_form;

  validations_form_input;
  validation_messages;
  validations_form;
  validations_form_upload;

  fullDataRadio;
  partialDataRadio;

  public selectedTarget: string ;


  objectGroups: any[] = [];
  SourceDnsID: any;
  TargetDnsId: any;
  selectedObjectGroups: Number[] = [];

  dataLakeTypeOptions: any=[];
  dataLakeAndReportsOptions: any=[];
  persisteneceEmrOptions: any=[];
  integratorSelectionOptions: any = [];
  JSONTOCSV_Validation_ReportsOptions: any=[];

  DisplayObject: boolean = false;
  selectedObjectGroupsString: string;
  selectedSource: string;
  migrationSelectedType: string;
  selectedSourceName: any;
  SourceId: void;
  targetId: any;
  sourceSystemTypeName: any;
  update: boolean;
  isReadOnly: boolean;
  updateDropdowns: boolean;
  mappingFilePath: any;
  mappingFile: any;
  mappingversion: any;
  version: any;
  buttonName: string;
  targetSystemTypeName: any;

  constructor(private msg: ErrorMessages, private dialogref: MatDialogRef<EtlMigrationPopupComponent>, private constants: constants, private localStorageSettings: LocalStorageSettingsService, private service:EtlService, private snackbar: MatSnackBar, private spinner: NgxUiLoaderService,private dialog: MatDialog, private validation: validationmethod, private formBuilder:FormBuilder, private commonTs: CommonTs, private snackBar: MatSnackBar,
     private commonService: CommonService,@Inject(MAT_DIALOG_DATA) public data:any) {
    this.validation_messages = this.msg.startMigrationPopup;
  }
  

  ngOnInit(): void {
   
    let dnsId = this.localStorageSettings.getSettings("WorkspaceId")
    // let dnsId = "27"
    this.update =false;
    this.updateDropdowns=true
    console.log(this.data);
    // if(this.data != null){
    //   this.update = true
    // }
      // this.selectedSourceName = this.data.selectedSourceName;
  this.selectedSource = this.data.selectedSourceName;
  this.selectedTarget = this.data.selectedTarget;
  this.SourceId = this.data.SourceId;
  this.targetId = this.data.TargetId;
  this.migrationSelectedType = this.data.MigrationType;
  this.sourceSystemTypeName = this.data.sourceSystemTypeName;
  this.targetSystemTypeName = this.data.targetSystemTypeName;
  this.targetSystemType= this.targetSystemTypeName
  this.migration.remarks = this.data.comment
  this.migration.dataLakeAndReports = this.data.dataLakeAndReports
  this.migration.dataLakeType = this.data.datalakeType
  this.migration.JSONTOCSV_Validation_Reports = this.data.jsontocsvvalidationreports
  this.migration.persistenceEmr = this.data.persistanceemr
  this.migration.dataExtractionType = this.data.dataextractiontype
  this.mappingFilePath = this.data.mappingFilePath
  this.version = this.data.mappingfileversion
  console.log(this.version)
  console.log(this.data.mappingfileversion)
  console.log(this.mappingFilePath)
  this.snapshotSelected = this.mappingFilePath 

  // call your popup screen specific methods
  this.onSourceSelection();
  this.migrationTypeRetrieved();
  this.checkForObjectNames();
    // this.validations_form.get('source')?.setValue(this.selectedSource);
    // this.selectedSource = "Jlw"
    // this.migrationSelectedType= "Data Migration"
    // this.selectedTarget =this.localStorageSettings.getSettings("SelectedDnsName");

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    this.validations_form = this.formBuilder.group({
      source: '',
      target:'',
      migrationType:'',
      fileData:'',
      fileUpload:'',
      remarks:'',
      objectGroups:'',
      dataLakeAndReports:'',
      dataLakeType:'',
      persistenceEmr:'',
      DatasetName:'',
      selectdataSet:'',
      JSONTOCSV_Validation_Reports:'',
      integrator:'',
      mappingFileversion:''
    })
    this.validations_form_input = this.formBuilder.group({
      remarks:'',
      DatasetName:'',
      snapshotVersion:'',
      dataExtractionType:'',
    })
    this.validations_form_upload = this.formBuilder.group({
      upload:'',
      fileData:'',
    })
    this.uploadFile = false;
    this.spinner.start();
  
    
   
    // let dnsId = this.localStorageSettings.getSettings("27");
    // let dnsId = "27"
    // this.service.retrieveSourceAndTraget(dnsId, "Source").subscribe((result)=>{
    //   this.selectedSource = result.sourceId;
    //   console.log(this.selectedSource);
    // })
    // this.commonService.getlookupVauleByLookUpType("DataMigrationType").subscribe(result=>{
    //   console.log(result);
    //   this.migrationType = result;
    // });
    this.commonService.getlookupVauleByLookUpType("System_name").subscribe(result=>{
      console.log(result);
      this.systemNames = result;
    });
    // this.service.retrieveSourceAndTraget(dnsId, "Source").subscribe((result)=>{
    //   this.selectedSource = result;
    //   console.log(this.selectedSource);
    // })
    console.log(this.data.migrationId)
    if(this.data.migrationId != null){
      this.isReadOnly = true;
      this.updateDropdowns = false
      console.log("update")
      const value = this.data.dataextractiontype
      console.log(value)
      this.onSelectDataExtraction(value)
      this.buttonName = "Update Run"
    }else{
      this.buttonName = "Start Run"
    }
    this.retrieveSnapshot();
    console.log(this.snapshot)
    
    // this.snapshotSelected = 'DM_Mappingfile_101'
    // this.validations_form_input.controls["snapshotVersion"].setValue('DM_Mappingfile_101')
    // this.validations_form_input.get('snapshotVersion').setValue('DM_Mappingfile_101')
 
    // this.validations_form_input.patchValue({
    //   snapshotVersion:this.snapshotSelected
    // })
    // this.onMappingSnapshotChange(this.snapshotSelected);
    this.retrieveSourceAndTarget()
     this.service.retrieveSourceAndTraget(dnsId, "Target").subscribe((result)=>{
      this.target = result;
      console.log(this.target);
      // this.selectedTarget = result
      this.migration.target = this.selectedTarget;
      let systemName = null;
      this.target.forEach((targetObject)=>{
      if(targetObject.envName === this.selectedTarget){
        systemName = targetObject.systemName;
        // this.TargetDnsId=targetObject.vaultConfigMstrId;

      }
    });
    this.systemNames.forEach(system=>{
      if (system.lookupvalueid === systemName){
        // this.targetSystemType = system.lookupvalue;
      }
    })
    console.log(this.targetSystemType);
    })
    this.spinner.stop();
   

  }
  getMappingFileBasedOnPath(mappingFilePath){
    // let dnsid= 187
    let dnsid=this.localStorageSettings.getSettings("dnsName")
    this.service.retrieveMappingFieBasednPath(mappingFilePath,dnsid).subscribe(
      result => {
          console.log(result);
          if (result===null) {
              
              console.log("No Data Found")
          } else {
              this.mappingFile = result;
              // this.snapshot = this.snapshotDetails.map(item => item.mappingversionfilename);
              console.log(this.mappingFile)
          }
          this.spinner.stop();
      },
      error => {
          console.error("Error snapshotDetails :", error);
          this.snapshotDetails = [];
          this.spinner.stop();
      }
  );
  }
 
  

  formValidation(){
    this.validations_form = new FormGroup({
      source: new FormControl('', [Validators.required]),
      target: new FormControl('', [Validators.required]),
      migrationType: new FormControl('', [Validators.required]),
      fileData: new FormControl(''),
      fileUpload: new FormControl(''),
      remarks: new FormControl('',[Validators.required]),
      objectGroups: new FormControl('', [Validators.required]),
      dataLakeAndReports: new FormControl('',[Validators.required]),
      dataLakeType: new FormControl('',[Validators.required]),
      persistenceEmr: new FormControl('',[Validators.required]),
      DatasetName: new FormControl('',[Validators.required]),
      JSONTOCSV_Validation_Reports: new FormControl('',[Validators.required]),
      snapshotVersion:new FormControl('',[Validators.required]),
      intergrator:new FormControl('',[Validators.required]),
      dataExtractionType: new FormControl('',[Validators.required])
      
    })
  }

  cancel(){
    this.dialog.closeAll();
  }


storeSelectedObjectGroupsAsString(): void {
  if(this.DisplayObject===true){
    this.selectedObjectGroupsString = this.selectedObjectGroups.join(',');
  }

}
updatemigration(){
  if( this.version == this.snapshotSelected){
    this.snackbar.open("No updates found", "Close", { duration: 3000 });
    return;
  }
  console.log("inside update Run")
  this.migration.mappingfileData = this.mappingfileData
  this.migration.migrationid = this.data.migrationId
  this.migration.mappingFileversion = this.snapshotSelected
  console.log(this.snapshotSelected)
  console.log(this.migration.mappingFileversion)
  if(this.mappingfileData.mappingFileData === "" || this.mappingfileData.mappingFileName === ""){
      this.snackBar.open("Please select the valid snapshot","OK",{duration:5000})
      return
  }
  this.dialogref.close({ data: this.migration });
}

  startmigration(): void {
 
    console.log("iiiiiiii")
    console.log(this.update)
    Object.keys(this.validations_form.controls).forEach(key => {
      this.validations_form.get(key).markAsTouched();
    });
    Object.keys(this.validations_form_input.controls).forEach(key => {
      this.validations_form_input.get(key).markAsTouched();
    });
    this.migration.fileData = this.fileData;
    this.migration.target = this.selectedTarget;
    this.migration.sourceextractiontype = this.selectedExtractionType;
    this.migration.mappingfileData = this.mappingfileData;
    this.storeSelectedObjectGroupsAsString();
    this.migration.selectedObjectGroups=this.selectedObjectGroupsString;
    this.migration.mappingFileversion =  this.mappingversion
    console.log(this.migration.dataExtractionType)
    console.log(this.migration)
    
    console.log(this.validations_form)
    console.log(this.validations_form_input)
    if (this.migration.target === this.migration.source) {
      this.snackBar.open("Source and Target cannot be the same", "OK", { duration: 5000 });
    } else if (this.migration.target === "" || this.migration.source === "" || this.migration.migrationType === "" || this.migration.remarks === "" || this.migration.mappingfileData === "") {
      this.snackBar.open("All mandatory fields must be filled", "OK", { duration: 5000 });
    } else if (this.validations_form.invalid || this.validations_form_input.invalid) {
      this.snackBar.open("All mandatory fields must be filled", "OK", { duration: 5000 });
    } else if(this.selectedObjectGroupsString==="" && this.DisplayObject===true){
      this.snackBar.open("All mandatory fields must be filled", "OK", { duration: 5000 });
    }else if(this.migration.migrationType.includes ("Data Virtualization")&& this.migration.dataLakeAndReports==="JSON" &&( this.migration.dataLakeType==="" || this.migration.persistenceEmr==="" || this.JSONTOCSV_Validation_ReportsOptions==="")){
      this.snackBar.open("All mandatory fields must be filled", "OK", { duration: 5000 });
    } else if (this.migration.migrationType.includes("Data Virtualization") && this.migration.dataLakeAndReports != "JSON" && this.migration.dataLakeAndReports != "Casewise Json" &&(this.migration.DatasetName==="" || this.migration.persistenceEmr==="" || this.JSONTOCSV_Validation_ReportsOptions==="")){
      this.snackBar.open("All mandatory fields must be filled", "OK", { duration: 5000 });
    }	 else if(this.mappingfileData.mappingFileData === "" || this.mappingfileData.mappingFileName === ""){
      this.snackBar.open("Please select the valid snapshot","OK",{duration:5000})
    }
    else {
      if (this.migration.migrationType.includes("Data Virtualization") && this.migration.dataExtractionType === "Full Data") {
        const confirmMessage = "Performing subsequent full data load operation will delete/overwrite existing data lake. Proceed with full data load?";
        const confirmDelete = confirm(confirmMessage);

        if (!confirmDelete) {
          // this.migration.migrationType = "";
          // this.migration.dataExtractionType = "";
          // this.DisplayObject=false;
          return;
        }
      }

      this.dialogref.close({ data: this.migration });
    }
    // this.dialogref.close({ data: this.migration });
  }

  onSourceSelection(){
    this.spinner.start();

    console.log(this.SourceId)
    this.SourceDnsID= this.SourceId
    console.log(this.SourceDnsID)
    this.migration.source = this.selectedSource;
    let systemName = null;
    // this.source.forEach(sourceObject=>{
    //   if(sourceObject.envName === event.value){
    //     systemName = sourceObject.systemName;
    //   }
    // })
    // this.systemNames.forEach(system=>{
    //   if (system.lookuptypeid = systemName){
    //     this.sourceSystemType = system.lookupvalue;
    //   }
    // })
    // Find systemName based on envName
    // const sourceObject = this.source.find(sourceObject => sourceObject.envName === event.value);
    // systemName = sourceObject ? sourceObject.systemName : null;

    // Find sourceSystemType based on systemName
    const system = this.systemNames.find(system => system.lookupvalueid === systemName);
    console.log(this.sourceSystemTypeName)
    this.sourceSystemType = this.sourceSystemTypeName
    console.log(this.sourceSystemType)
    // event.value=this.migration.migrationType;
    // this.onMigrationTypeSelection(event)
    // this.migrationTypeRetrieved
    this.spinner.stop();
  }
/**
  onTargetSelection(event){
    this.spinner.start();
    this.migration.target = event.value;
    let systemName = null;
    this.target.forEach((targetObject)=>{
      if(targetObject.envName === event.value){
        systemName = targetObject.systemName;
      }
    });
    this.systemNames.forEach(system=>{
      if (system.lookuptypeid = systemName){
        this.targetSystemType = system.lookupvalue;
      }
    })
    console.log(this.targetSystemType);
    console.log(event.value);
    this.spinner.stop();
  }
*/
onObjectGroupSelection(event: any): void {
  this.spinner.start();
  this.selectedObjectGroups = event.value;
  this.spinner.stop();
}
  onMigrationTypeSelection(event){
    if (event.value.includes ("Data Virtualization") && (!this.dataLakeAndReportsOptions.length || !this.dataLakeTypeOptions.length)) {
      this.commonService.getlookupVauleByLookUpType("dataLakeAndReports").subscribe(result => {
        console.log(result);
        this.dataLakeAndReportsOptions = result;

      });
      this.commonService.getlookupVauleByLookUpType("DATALAKE_TYPE").subscribe(result => {
        console.log(result);
        this.dataLakeTypeOptions = result;
      });
      this.commonService.getlookupVauleByLookUpType("JSONTOCSV_Validation_Reports").subscribe(result => {
        console.log(result);
        this.persisteneceEmrOptions = result;
        this.JSONTOCSV_Validation_ReportsOptions=result;
      })
    }
    this.migration.dataLakeAndReports="";
    this.migration.dataLakeType="";

    this.partialData=false;
    this.migration.migrationType = event.value;
    console.log(this.sourceSystemType);
    console.log(this.targetSystemType);
    if (event.value === 'Data Migration'){
      if (this.sourceSystemType == 'VAULT'){
        this.partialData = true;
      }
    }else{
      this.partialData = true;
    }
    this.checkForObjectNames();

    console.log(event.value);
  }

 checkForObjectNames() {
  this.spinner.start();
  let dnsid = this.localStorageSettings.getSettings("dnsName")
  console.log(this.sourceSystemType)
  this.targetSystemType= this.targetSystemTypeName
  console.log(this.targetSystemType)

 
  /**
 * @Modified by Sujeet Sharma
 * @Date 2025-10-21
 * Removed the condition that restricted displaying the Group Name based on 
 * migration type and system type. Now Group Name will be displayed 
 * irrespective of the selected migration type.
 */


   // Check if migration type is "Data Migration (Direct Data API)" - HIDE object groups
  if (this.migration.migrationType && this.migration.migrationType.includes('Data Virtualization (Direct Data API)')) {
    console.log("Hiding Object Groups for Direct Data API migration type");
    this.DisplayObject = false;
    this.spinner.stop();
    return;
  }
  // if ((this.sourceSystemType === "VAULT" && this.migration.migrationType===( "Data Virtualization (Loader)"))
  //    || ((this.sourceSystemType === "VAULT" && (this.targetSystemType.toLowerCase() === "argus"||this.targetSystemType.toLowerCase() === "arisg"||this.targetSystemType.toLowerCase() === "arisj" || this.targetSystemType.toLowerCase() === "database"))
  //    && this.migration.migrationType === "Data Migration")) {//manit

      this.DisplayObject = true;

        if (!this.SourceDnsID) {
    console.warn("Source DNS ID is not available, using current DNS ID:", dnsid);
    this.SourceDnsID = dnsid; // Fallback to current DNS ID
  }
      console.log(this.SourceDnsID, this.TargetDnsId);
      this.service.getObjectGroupsNames(this.SourceDnsID, dnsid).subscribe(
          result => {
              console.log(result);
              if (result===null || result === undefined) {
                console.log("No Data Found from API - null or undefined response");
                  this.objectGroups = ["No Object Groups Found"];
                  this.DisplayObject = true;
                  console.log("No Data Found")

              } else if (Array.isArray(result) && result.length === 0){
                this.objectGroups = ["No Object Group Avaiable"];
                this.DisplayObject = true;
              } else if (typeof result === 'string' && result.includes("No Object Groups")) {
        console.log("String response indicating no object groups");
        this.objectGroups = [result];
        this.DisplayObject = true; 
                }  else {
                  this.objectGroups = result;
                  this.DisplayObject = true;
                    console.log("Object groups loaded successfully. Count:", this.objectGroups.length);
              }
              this.spinner.stop();
          },
          error => {
              console.error("Error fetching object groups:", error);
              this.objectGroups = [];
              this.DisplayObject = true;
              this.spinner.stop();
                    this.snackBar.open("Failed to load object groups", "OK", { duration: 5000 });

          }
      );
    }
  




  onSelectDataExtraction(value){
    console.log(this.selectedObjectGroups);
    console.log(value)
    this.migration.dataExtractionType = value;
    if(value === "Partial Data"){
      this.uploadFile = true;
    }else{
      this.uploadFile = false;
      this.fileData.fileData = '';
      this.fileData.fileName = '';
    }

  }



  imagePhotofunction($event,filecheck): void {
    this.readThisimage($event.target,filecheck);
  }

  readThisimage(inputValue: any,filecheck:any): void {
    let ischeckfile=false
   var file: File = inputValue.files[0];
   var FileS: File = inputValue.files[0];
   console.log("file type")
   console.log(file.type)
   let flag:boolean= this.commonTs.hasMultipleExtensions(file);
   if (!flag) {
    const extension = file.name.substring(file.name.lastIndexOf("."));
    if(filecheck==extension){
     console.log(file.size / 1000)
     var size = file.size / 1000
     /**
      * Modified by Ashwin M
      * 27/02/2023
      * code modified to increase file upload size limit to 200MB
      */
     if (size <= 200000) {
           var fileName = FileS.name;
           //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

           var photo: FileReader = new FileReader();
           photo.onloadend = e => {
             var img = photo.result;
             var photobase64result = photo.result.toString().split(",", 2)[1];

             // this is to check the file is empty or not
             if (photobase64result == null) {

             } else {
               let imagephoto = photo.result.toString();
               this.fileData.fileData = photobase64result;
               this.fileData.fileName = fileName;
             }
           };
           photo.readAsDataURL(file);
     } else {
       this.snackBar.open("Selected file " + file.name + ", size should be less than 200MB", "OK", {
         duration: 5000,
       });
     }
    } else {
      this.snackBar.open(file.name + " is a invalid file type ,please select "+filecheck+" file", "OK", {
        duration: 5000,
      });
    }
   } else {
     this.snackBar.open(file.name + " is a invalid file type ", "OK", {
       duration: 5000,
     });
   }
 }
 /**
  * Added By Kameshwar
  * Date: 24-05-2024
  * @param event
  */
 onDataLakeTypeSelection(event) {
  this.spinner.start();
  this.migration.dataLakeType=event.value;
  this.spinner.stop();
}

onDataLakeAndReportsSelection(event) {
  this.spinner.start();
  this.migration.dataLakeAndReports=event.value;
  this.spinner.stop();
}

onPersistenceEmrSelection(event) {
  this.migration.persistenceEmr=event.value;
  this.migration.persistenceClusterId = "0";
}

validateInput(event: any) {
  const input = event.target.value;
  const regex = /^[a-z0-9-_]+$/;
  if (!regex.test(input)) {
    event.target.value = input.slice(0, -1);
  }
}
onValidationSelection(event) {
  this.spinner.start();
  this.migration.JSONTOCSV_Validation_Reports=event.value;
  this.spinner.stop();
}

  onMappingSnapshotChange(value){
    console.log("********************")
    console.log(value)
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    this.spinner.start();
    this.snapshotSelected = value;
    console.log(this.snapshotSelected)
    this.mappingversion = this.snapshotSelected
    this.spinner.stop();
    this.service.getMappingFileFromS3(this.snapshotSelected,dnsId).subscribe(
      result =>{
        console.log(result);
        if (result.error) {
        console.log("++++++++++++++++++++++++++++++++++++++++++++")
        this.snackBar.open(result.error,"OK",{duration:5000})
        // this.statevaluechange.fileName = response.fileName;
        // this.statevaluechange.fileData = response.fileData;
        // this.FormValid.controls.imageName.setValue(response.fileName);
          console.log("No Data Found")
      } else {
        this.mappingfileData.mappingFileData=result.fileData
        this.mappingfileData.mappingFileName=result.fileName
        console.log( this.mappingfileData.mappingFileData.length)
        console.log( this.mappingfileData.mappingFileName)
        console.log( this.mappingfileData)
      }
      this.spinner.stop();
  },
  error => {
    
     console.log("Inside error of snapshot")
    let userMessage = "Issue with selected snapshot please choose someother .";
   if (error.error && error.error.error) {
    const rawMessage = error.error.error;

    if (rawMessage.includes("The specified key does not exist")) {
      userMessage = "The requested file was not found in storage.";
    } else if (rawMessage.includes("S3 access error")) {
      userMessage = "Could not access storage. Please contact support.";
    } else {
      userMessage = rawMessage; // fallback
    }
  }
      this.snackBar.open(userMessage, "OK", { duration: 5000 });
      console.error("Error snapshotDetails :", error);
      this.snapshotDetails = [];
      this.mappingfileData.mappingFileData=""
        this.mappingfileData.mappingFileName=""
      this.spinner.stop();
  }
  );
}
snapshotDetails
retrieveSnapshot(){
  let dnsId = this.localStorageSettings.getSettings("dnsName");
  this.service.retrieveSnapshotDetails(dnsId).subscribe(
    result => {
        console.log(result);
        if (result===null) {
            this.snapshotDetails = ["No Snapshot Details Found"];
            console.log("No Data Found")
        } else {
            this.snapshotDetails = result;
            this.snapshot = this.snapshotDetails.map(item => item.mappingversionfilename);
            console.log(this.snapshot)
            if(this.isReadOnly){
              console.log(this.version)
            this.snapshotSelected = this.version
            // this.validations_form_input.controls["snapshotVersion"].setValue('DM_Mappingfile_101')
            // this.validations_form_input.get('snapshotVersion').setValue('DM_Mappingfile_101')
            this.validations_form_input.patchValue({
              snapshotVersion: this.snapshotSelected
            });
            this.onMappingSnapshotChange(this.snapshotSelected);
            }
        }
        
        // this.snapshotSelected = 'DM_Mappingfile_101';
        // this.validations_form_input.patchValue({
        //   snapshotVersion: this.snapshotSelected
        // });
        // this.onMappingSnapshotChange(this.snapshotSelected);
  
        this.spinner.stop();
    },
    error => {
        console.error("Error snapshotDetails :", error);
        this.snapshotDetails = [];
        this.spinner.stop();
    }
);

}
retrieveSourceAndTarget() {
  console.log("Calling retrieveSourceAndTarget");
  // const dnsId = "27";
  const dnsId =  this.localStorageSettings.getSettings("WorkspaceId")
  this.spinner.start();
  this.service.retrieveSourceAndTraget(dnsId, "Source").subscribe({
    next: (result) => {
     
      console.log(result);
      if (result === null) {
        console.log("No Data Found");
        this.SourceDnsID = dnsId;

      } else {
        console.log(result.sourceEnvName)
        this.selectedSourceName = result.sourceEnvName;
        console.log(this.selectedSourceName)
        this.selectedSource = this.selectedSourceName
        this.selectedTarget = result.targetEnvName
        this.SourceId = result.sourceId
        this.targetId = result.targetId
         this.SourceDnsID = result.sourceId; 
        this.TargetDnsId = result.targetId;
        console.log( result.targetEnvName)
        console.log(this.selectedTarget)
        this.migrationSelectedType = result.mappingTypeName
        this.sourceSystemTypeName = result.sourceSystemName
        this.targetSystemTypeName = result.targetSystemName
        this.validations_form.get('source')?.setValue(this.selectedSource);
        this.validations_form.get('target')?.setValue(this.selectedTarget);
        this.validations_form.get('migrationType')?.setValue(this.migrationSelectedType);
        this.onSourceSelection()
        this.migrationTypeRetrieved()
       this.checkForObjectNames();
        
      }
      this.spinner.stop();
    },
    error: (err) => {
      console.error("Error snapshotDetails:", err);
      this.checkForObjectNames();
      this.spinner.stop();
    }
  });
}
migrationTypeRetrieved(){
  console.log(this.migrationSelectedType.includes('Data Virtualization') )
  
  if ((this.migrationSelectedType.includes('Data Virtualization')||  this.migrationSelectedType === "Vault Safety Data Ingestion") && (!this.dataLakeAndReportsOptions.length || !this.dataLakeTypeOptions.length)) {
    this.commonService.getlookupVauleByLookUpType("dataLakeAndReports").subscribe(result => {
      console.log(result);
      this.dataLakeAndReportsOptions = result;

    });
    this.commonService.getlookupVauleByLookUpType("DATALAKE_TYPE").subscribe(result => {
      console.log(result);
      this.dataLakeTypeOptions = result;
    });
    this.commonService.getlookupVauleByLookUpType("JSONTOCSV_Validation_Reports").subscribe(result => {
      console.log(result);
      this.persisteneceEmrOptions = result;
      this.JSONTOCSV_Validation_ReportsOptions=result;
    });
    this.commonService.getlookupVauleByLookUpType("PARQUET").subscribe(result => {
      console.log(result);
      this.integratorSelectionOptions = result;
      // this.JSONTOCSV_Validation_ReportsOptions=result;
    })

  }
  this.migration.dataLakeAndReports="";
  this.migration.dataLakeType="";

  this.partialData=false;
  this.migration.migrationType =this.migrationSelectedType;
  console.log(this.sourceSystemType);
  console.log(this.targetSystemType);
  if (this.migrationSelectedType === 'Data Migration'){
    if (this.sourceSystemType == 'VAULT'){
      this.partialData = true;
    }
  }else{
    this.partialData = true;
  }
 

  // console.log(event.value);
}

onIntegratorSelection(event){
  console.log(event)
this.migration.intergrator=event.value
}

}
